import * as _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { exportToExcel, fetchPage } from "../../../Api/azure";
import { getItemGroupData } from "../../../Helpers/table";
import {
    AttributeCell,
    AttributeRow,
    DataGridContent,
    Link,
    PagedQuery,
    PagedQueryResponse,
    PagedQueryResponseRow,
    PagedQueryResponseRowItem,
    PagedQuerySortBy,
} from "../../../Models";
import { DataGridReusable } from "./TableReusable";

interface IPagedDataGridProps {
    route: string;
    headers: string[];
    name: string;
    exportable: boolean;
}

export default function PagedDataGrid(props: IPagedDataGridProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<DataGridContent>(
        getItemGroupData(props.headers, [])
    );
    const [pages, setPages] = useState<number>(-1);
    const [tableState, setTableState] = useState<any>({
        pageIndex: 0,
        pageSize: 10,
        sortBy: [],
    });
    const [routeChanged, setRouteChanged] = useState<boolean>(false);
    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        setRouteChanged(!routeChanged);
        fetchData(tableState.state, 0);
    }, [props.route]);

    // Callback to update the table state and keep in sync
    const setTableStateHandler = (newTableState) =>
        setTableState(newTableState);

    const defaultSort: any = () => data.columns[0].accessor;

    function handleResponse(response: PagedQueryResponse, pageSize: number) {
        if (response) {
            var rows: AttributeRow[] = [];
            _.map(response.rows, (responseRow: PagedQueryResponseRow) => {
                var row: AttributeRow = { items: [] };
                _.map(responseRow.items, (item: PagedQueryResponseRowItem) => {
                    if (item.id && item.type) {
                        row.items.push({
                            url: {
                                id: item.id,
                                type: item.type,
                                description: item.description,
                                url: item.id,
                            },
                        } as AttributeCell);
                    } else {
                        row.items.push({
                            description: item.description,
                            url: {} as Link,
                        });
                    }
                });
                rows.push(row);
            });

            setPages(
                response.totalCount < pageSize
                    ? 1
                    : Math.ceil(response.totalCount / pageSize)
            );
            setData(getItemGroupData(props.headers, rows));
        }
    }

    const getPagedQuery: Function = (state, page): PagedQuery => {
        var sort: PagedQuerySortBy =
            state?.sortBy?.length > 0
                ? {
                      field: state?.sortBy[0].id,
                      desc: state?.sortBy[0].desc,
                  }
                : {
                      field: defaultSort(),
                      desc: false,
                  };

        var query: PagedQuery = {
            filters: [],
            page: page,
            pageSize: state?.pageSize,
            sort: sort,
        };

        _.map(state?.filters, (filter: any) => {
            query?.filters.push({ field: filter.id, value: filter.value });
        });

        return query;
    };

    const fetchData = async (state, page) => {
        setLoading(true);
        var query = getPagedQuery(state, page);
        const response: PagedQueryResponse = await fetchPage(
            props.route,
            query
        );
        handleResponse(response, state?.pageSize);
        setLoading(false);
    };

    const exportAllToExcel: Function = async () => {
        const route = `${props.route}/exporttoexcel`;
        const query = getPagedQuery(tableState.state);
        exportToExcel(route, query, props.name);
    };

    return (
        <div>
            <DataGridReusable
                filterable={true}
                pages={pages}
                loading={loading}
                manual={true}
                fetchData={fetchData}
                defaultPageSize={20}
                data={data.data}
                columns={data.columns}
                showPagination={true}
                setTableState={setTableStateHandler}
                routeChanged={routeChanged}
            />
            {props.exportable && (
                <button
                    className="btn btn-primary mt-3 float-end"
                    onClick={() => exportAllToExcel()}
                >
                    Export all to Excel
                </button>
            )}
        </div>
    );
}
